import React from 'react';
import styled, { css } from 'react-emotion';

const listStyle = css`
  list-style-type: none;
  margin: 0;

  & h1 {
    color: inherit;
    text-decoration: underline;
  }

  & a {
    color: black;
    cursor: pointer;
    opacity: 1;
    transition: opacity .15s ease-in;
    transition: color .15s ease-in;

    &:hover {
      text-decoration: none;
      box-shadow: none;
      opacity: .5;
      transition: opacity .15s ease-in;
    }
  }
`;

export const List = ({ children }) => {
  return (
    <ul className={listStyle}>
      { children }
    </ul>
  )
}



// WEBPACK FOOTER //
// ./src/components/Lists/index.js